"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeHxPresenceResult = void 0;
function deserializeHxPresenceResult(values) {
    var i = 0;
    var emailAddress = values[i++];
    var availability = values[i++];
    if (i != values.length) {
        throw "Result values not parsed completely";
    }
    return { emailAddress: emailAddress, availability: availability };
}
exports.deserializeHxPresenceResult = deserializeHxPresenceResult;
